import React, {FC, useEffect, useMemo, useRef} from "react";
import {DrawerProps} from "./Drawer.types";
import styles from "./Drawer.module.scss";

const Drawer: FC<DrawerProps> = ({open, size, children, onAnimationEnd}) => {
    const ref = useRef(null);

    const classNames = useMemo(() => {
        return [styles.Drawer, styles[size], open ? styles.open : undefined].join(" ");
    }, [size, open]);


    const onAnimationEndListener = () => {
        onAnimationEnd?.();
        ref.current?.removeEventListener('animationend', onAnimationEndListener);
    }

    useEffect(() => {
        if(!open){
            ref.current?.addEventListener('animationend', onAnimationEndListener);
        }
    }, [open]);

    return (
        <div className={classNames} data-testid="Drawer" ref={ref}>
            <div className={styles.DrawerContent}>
                {children}
            </div>
        </div>
    );
};

export default Drawer;
